module.exports = __webpack_public_path__ + "static/dune-logo-b-78d5da1906fd5b3f636e92a5feeaca29.png";